import { InspectionQuestion } from "../types/inspectionWorkflow";
import { InspectionResult } from "src/services/inspectionService";

/** A single grouped-results entry: a question id and all of its captured results. */
export type GroupedResultEntry = [string, InspectionResult[]];

/** True when a result is still awaiting AI analysis (aiResult/confirmedResult === "PENDING"). */
export const isAnalysisPending = (result: InspectionResult): boolean =>
    result.aiResult?.toUpperCase() === "PENDING" ||
    result.confirmedResult?.toUpperCase() === "PENDING";

/**
 * Orders grouped inspection results by the workflow's question order.
 *
 * Results are grouped by `questionId` upstream (see
 * `InspectionService.fetchInspectionWithPresignedUrls`). Both the review page
 * and the resume-draft page need to render those groups in the same order the
 * questions appear in the workflow, so this ordering lives in one shared,
 * pure helper.
 */
export const orderGroupedResultsByQuestion = (
    groupedResults: Record<string, InspectionResult[]>,
    questions: InspectionQuestion[]
): GroupedResultEntry[] =>
    Object.entries(groupedResults).sort(
        ([a], [b]) =>
            questions.findIndex((q) => q.id === a) -
            questions.findIndex((q) => q.id === b)
    );
